import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCateringEventFormats } from '../../api/fetch-catering-event-formats';

export const fetchCateringEventFormatsThunk = createAsyncThunk(
    'fetchCateringEventFormats',
    async () => fetchCateringEventFormats(),
);
